<template>
	<el-dialog
		title="个人设置"
		:append-to-body="true"
		:modal-append-to-body="falseValue"
		:close-on-click-modal="falseValue"
		:visible.sync="showDialog"
		:modal="falseValue"
		custom-class="dialog-style list-dialog demo-sty_2"
		width="1000px"
		@close="dialogClose"
		v-el-drag-dialog
		v-el-dialog-center
	>
		<div id="containt">
			<div class="detail-wrap">
				<el-form ref="editForm" :model="user">
					<div class="d-header clearfix">
						<div class="fl">
							<i class="el-icon-info" />
							{{ dataId ? '查看' : '新增' }}用户
						</div>
						<div class="fr">
							<el-button type="primary" plain class="button-sty" @click="reloadContent" icon="el-icon-refresh-right">重置</el-button>
							<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
						</div>
					</div>
					<div class="d-cont">
						<div class="d-item">
							<div class="title first"><b>基本信息</b></div>
							<table class="table-detail">
								<tbody>
									<tr>
										<th>
											<em class="f-red">*</em>
											登录名
										</th>
										<td>
											<el-form-item prop="loginAccount" :rules="[{ required: true, trigger: 'blur' }]">
												<template v-if="dataId">
													<el-input
														size="small"
														v-model="user.loginAccount"
														maxlength="255"
														autocomplete="off"
														lay-verify="required"
														required=""
														:readonly="true"
													/>
												</template>
												<template v-else>
													<el-input
														size="small"
														v-model="user.loginAccount"
														maxlength="255"
														autocomplete="off"
														lay-verify="required"
														required=""
														clearable
													/>
												</template>
											</el-form-item>
										</td>
										<th>手机</th>
										<td>
											<el-form-item prop="mobile" :rules="[{ required: false, trigger: 'blur' }]">
												<el-input size="small" v-model="user.mobile" type="text" maxlength="255" autocomplete="off" lay-verify="required|phone" clearable />
											</el-form-item>
										</td>
										<th>密码</th>
										<td>
											<el-form-item prop="password" :rules="passRules">
												<el-input
													size="small"
													type="password"
													v-model="user.password"
													show-password
													maxlength="255"
													autocomplete="off"
													auto-complete="new-password"
													clearable
												/>
											</el-form-item>
										</td>
										<th>确认密码</th>
										<td>
											<el-form-item prop="rePassword" :rules="pass2Rules">
												<el-input
													size="small"
													type="password"
													v-model="user.rePassword"
													show-password
													maxlength="255"
													autocomplete="off"
													auto-complete="new-password"
													lay-verify="confirmPass"
													clearable
												/>
											</el-form-item>
										</td>
									</tr>
									<tr>
										<th>
											<em class="f-red">*</em>
											姓名
										</th>
										<td>
											<el-form-item prop="nickName" :rules="[{ required: true, trigger: 'blur' }]">
												<el-input size="small" v-model="user.nickName" maxlength="200" lay-verify="required" required="" clearable />
											</el-form-item>
										</td>
										<th>性别</th>
										<td>
											<el-radio-group v-model="user.gender">
												<el-radio :label="1">男</el-radio>
												<el-radio :label="2">女</el-radio>
											</el-radio-group>
										</td>
										<th>出生日期</th>
										<td><el-date-picker size="small" v-model="user.birth" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" clearable /></td>
										<th>邮编</th>
										<td><el-input size="small" id="zipCode" v-model="user.zipCode" name="zipCode" maxlength="255" clearable /></td>
									</tr>
									<tr>
										<th>地址</th>
										<td colspan="3"><el-input size="small" v-model="user.address" class="b" maxlength="255" clearable /></td>
										<th>设置</th>
										<td colspan="3"><el-checkbox label="是否启用" v-model="user.enabled"></el-checkbox></td>
									</tr>
									<tr>
										<th>头像</th>
										<td colspan="7">
											<baseUpload :limit="1" accept="image/png, image/jpeg" multi="false" :file.sync="user.headPhotoUrl" dataType="medium"></baseUpload>
										</td>
									</tr>
									<tr>
										<th>创建人</th>
										<td>{{ user.createBy }}</td>
										<th>创建时间</th>
										<td>{{ user.createDate }}</td>
										<th>更新人</th>
										<td>{{ user.modifyBy }}</td>
										<th>更新时间</th>
										<td>{{ user.modifyDate }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</el-form>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'userInfo',
	components: {},
	props: ['_dataId'],
	created() {
		if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
	},
	mounted() {
		this.getData();
	},
	data() {
		var validatePass = (rule, value, callback) => {
			const isPassRequired = !this.dataId;
			if (isPassRequired && (value == '' || value == undefined)) {
				callback(new Error('密码不能为空'));
			} else {
				callback();
			}
			this.$refs.editForm.validateField('rePassword');
		};
		var validatePass2 = (rule, value, callback) => {
			const isPassRequired = !this.dataId;
			const rePassword = value != undefined ? value : '';
			const password = this.user.password != undefined ? this.user.password : '';

			if (isPassRequired && rePassword == '') {
				callback(new Error('确认密码不能为空'));
			} else if (rePassword != password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			showDialog: true,
			falseValue: false,
			dataId: '',
			hBtn: true,
			user: {},
			vxeOption: {},
			companyInfoOption: {},
			userRoleOption: {},
			showContent: true,
			passRules: [{ validator: validatePass, trigger: 'blur', required: false }],
			pass2Rules: [{ validator: validatePass2, trigger: 'blur', required: false }]
		};
	},
	methods: {
		getData() {
			let t = this._dataId;
			if (this.dataId && !isNaN(this.dataId)) {
				this.isEdit = true;
				this.$http({
					url: USER_PREFIX + `/user/get`,
					method: `post`,
					data: {
						id: this.dataId
					},
					isLoading: true,
					modalStrictly: true,
					success: res => {
						var user = res.objx || {};
						this.user = res.objx || {};
						this.user.password = '';
					}
				});
			} else {
				this.isEdit = false;
				this.user = {
					enabled: true
				};
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = USER_PREFIX + '/user/updateUserInfo';
						this.$http({
							url: url,
							method: `post`,
							data: this.user,
							isLoading: true,
							success: res => {
								this.$message({
									message: res.content,
									type: 'success',
									duration: 500,
									onClose: t => {
										this.reloadContent();
									}
								});
							}
						});
					});
				}
			});
		},
		dialogClose() {
			this.$emit('update:visiable', false);
		},
		reloadContent() {
			this.user = {};
			this.getData();
		}
	}
};
</script>
